import type { ComponentTemplate } from "schemas/generated/componentTemplates";

export const staySubscriptionWidget: ComponentTemplate = {
  id: "0c535bed-fb96-4e33-a67b-12b39c82ddbb",
  storeId: null,

  scope: "left-bar",
  type: "component",
  name: "Product/Stay Ai Subscription Widget",
  leftBarCategory: { main: "productIntegrations", subCategory: "subscription" },
  preview: "integrations/stay-ai-subscription.svg",
  transforms: [],
  template: {
    id: "$uid",
    type: "staySubscriptionWidget",
    props: {},
  },
};
